import en from './en/translation.json';
import nl from './nl/translation.json';
import ar from './ar/translation.json';
import ja from './ja/translation.json';
import de from './de/translation.json';
import es from './es/translation.json';
import fr from './fr/translation.json';
import it from './it/translation.json';
import ko from './ko/translation.json';
import pt from './pt/translation.json';
import tr from './tr/translation.json';
import uk from './uk/translation.json';
import zh from './zh/translation.json';
import zu from './zu/translation.json';

export const config = {
  defaultNS: 'translation',
  resources: {
    en: en,
    nl: nl,
    ar: ar,
    ja: ja,
    de: de,
    es: es,
    fr: fr,
    it: it,
    ko: ko,
    pt: pt,
    tr: tr,
    zh: zh,
    zu: zu,
    uk: uk,
  },
  lng: 'en',
  fallbackLng: 'en',
};
